// extracted by mini-css-extract-plugin
module.exports = {"countdown":"ph-z","srOnly":"qh-z"};